export const AUTH_DOMAIN_LIST = [
    'authmeet.atviettelsolutions.com',
    'ops.viettelmeet.com'
];
export const GUEST_INFO = {
    DISPLAY_NAME: 'displayNameGuest'
};
/**
 * Danh sách config code
 */
export const CONFIG_CODE = {
    DURATION_TIMOUT_PREJOIN: 'DURATION_TIMOUT_PREJOIN',
    DURATION_MEETING_MIN_TO_SHOW_FEEDBACK: 'DURATION_MEETING_MIN_TO_SHOW_FEEDBACK',
    ENABLE_SHOW_FEEDBACK: 'ENABLE_SHOW_FEEDBACK',
    DEFAULT_CAMERA_STATE: 'DEFAULT_CAMERA_STATE',
    DEFAULT_MIC_STATE: 'DEFAULT_MIC_STATE',
    GUEST_JOIN: 'GUEST_JOIN',
    RECORD_AUDIO_ONLY: 'RECORD_AUDIO_ONLY'
};
/**
 * Danh sách config code gọi api
 */
export const CONFIG_CODE_GET = [
    CONFIG_CODE.DEFAULT_CAMERA_STATE,
    CONFIG_CODE.DEFAULT_CAMERA_STATE,
    CONFIG_CODE.DURATION_MEETING_MIN_TO_SHOW_FEEDBACK,
    CONFIG_CODE.DURATION_TIMOUT_PREJOIN,
    CONFIG_CODE.ENABLE_SHOW_FEEDBACK,
    CONFIG_CODE.RECORD_AUDIO_ONLY
];
/**
 * Danh sách quyền người dùng trong phòng
 */
export const ROLE_PARTICIPANT_ROOM = {
    OWNER: 'owner',
    HOST: 'host',
    CO_HOST: 'coHost',
    PARTICIPANT: 'participant'
};
/**
 * Danh sách quyền điều hành
 */
export const MODERATOR_ROLE_PARTICIPANT = [ROLE_PARTICIPANT_ROOM.OWNER, ROLE_PARTICIPANT_ROOM.HOST, ROLE_PARTICIPANT_ROOM.CO_HOST];
/**
 * Danh sách kiểu thông báo
 */
export const TYPE_TOAST = {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error'
};
/**
 * Trạng thái tab
 */
export const DOCUMENT_VISIBILITY_STATE = {
    VISIBILE: 'visible',
    HIDDEN: 'hidden'
};
